<template>
  <div class="h-100">
    <div v-if="poster && poster.content" class="container-fluid text-center h-100" :key="$route.params.id">
      <div class="row bg-primary pt-2 pb-2">
        <div class="col text-start font-weight-bold" v-if="!isMobile()">{{ poster.presentation_code }}
          <span v-html="poster.title"></span>
        </div>
        <div class="col text-start smaller-blank" v-else>{{ poster.presentation_code }} <span
          v-html="poster.title"></span></div>
      </div>
      <div class="row bg-primary font-weight-bold mb-2" v-if="!isMobile()">
        <div class="col col-3 col-lg-3 d-flex ">
          <router-link :to="getBackUrl()" class="btn btn-sm mr-auto my-auto">
            <icon :icon="['fal', 'arrow-circle-left']" class="fa-3x"/>
            <div class="my-auto">Back</div>
          </router-link>
          <button class="btn btn-sm d-lg-none" type="button" data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasAction"
                  aria-controls="staticBackdrop">
            <icon :icon="['fal', 'circle-caret-down']" class="fa-3x"/>
            <div>More actions</div>
          </button>
          <div class="d-none d-lg-block">
            <router-link class="btn btn-sm" :to="'/viewer/abstract/' + poster.abstract_id"
                         title="Switch to abstract">
              <icon :icon="['fab', 'wpforms']" class="fa-3x"/>
              <div class="my-auto">Abstract</div>
            </router-link>
            <router-link class="btn btn-sm" :to="'/viewer/video/' + poster.abstract_id"
                         v-if="poster.content.video"
                         title="Switch to abstract">
              <icon :icon="['fal', 'film']" class="fa-3x"/>
              <div class="my-auto">Video</div>
            </router-link>
            <a class="btn btn-sm" target="_blank" :href="getPDFUrl('poster')"
               v-if="poster.content.confirm_download && poster.content.confirm_download === true">
              <icon :icon="['fal', 'file-download']" class="fa-3x"/>
              <div>Download</div>
            </a>
          </div>
        </div>
        <div v-if="isMobile()" class="w-100 d-md-none"></div>
        <div class="col">
          <template v-if="filteredPosters">
            <router-link class="btn btn-sm font-weight-bold" v-if="getPosition() > 0"
                         :to="'/viewer/' + filteredPosters[getPosition() - 1].abstract_id">
              <icon :icon="['fal', 'arrow-left']" class="fa-3x"/>
              <div class="my-auto">Last</div>
            </router-link>
            <button class="btn btn-sm border-0 font-weight-bold disabled" v-else>
              <icon :icon="['fal', 'arrow-left']" class="fa-3x"/>
              <div class="my-auto">Last</div>
            </button>
          </template>
          <button v-if="isIOS === false" class="btn btn-sm font-weight-bold" v-on:click="setScale(scale - 0.1)"
                  title="Zoom out">
            <icon :icon="['fal', 'search-minus']" class="fa-3x"/>
            <div class="my-auto">Zoom out</div>
          </button>
          <button v-if="isIOS === false" class="btn btn-sm font-weight-bold " v-on:click="scale = 'page-width'"
                  title="Zoom reset">
            <icon :icon="['fal', 'search']" class="fa-3x"/>
            <div class="my-auto">Reset</div>
          </button>
          <button v-if="isIOS === false" class="btn btn-sm font-weight-bold " v-on:click="setScale(scale + 0.1)"
                  title="Zoom in">
            <icon :icon="['fal', 'search-plus']" class="fa-3x"/>
            <div class="my-auto">Zoom in</div>
          </button>

          <template v-if="filteredPosters">
            <router-link class="btn btn-sm"
                         v-if="filteredPosters.length > getPosition() + 1"
                         :to="'/viewer/' + filteredPosters[getPosition() + 1].abstract_id">
              <icon :icon="['fal', 'arrow-right']" class="fa-3x"/>
              <div class="my-auto">Next</div>
            </router-link>
            <button class="btn btn-sm border-0 font-weight-bold disabled" v-else>
              <icon :icon="['fal', 'arrow-right']" class="fa-3x"/>
              <div class="my-auto">Next</div>
            </button>
          </template>
        </div>
        <div class="col d-none d-lg-block col-lg-3 justify-content-evenly">
          <button class="btn btn-sm " data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasComments"
                  aria-controls="offcanvasComments">
            <icon :icon="['fal', 'comments']" class="fa-3x"/>
            <div class="my-auto">Comments</div>
          </button>
          <button class="btn btn-sm pointer-click flex-grow-1"
                  v-on:click="openContact(poster.abstract_id)">
            <icon :icon="['fal', 'message']" class="fa-3x"/>
            <div class="my-auto">&nbsp;Contact</div>
          </button>
        </div>
        <div class="row" v-if="poster.content.audio">
          <div class="col" v-if="poster.content.audio">
            <AudioPlayer :file="getAudioUrl(poster.content.audio)" :loop="false" :auto-play="false"></AudioPlayer>
          </div>
        </div>
      </div>
      <div class="row bg-primary font-weight-bold mb-2" v-else>
        <div class="col d-flex">
          <router-link :to="getBackUrl()" class="btn btn-sm mr-auto my-auto">
            <icon :icon="['fal', 'arrow-circle-left']" class="fa-3x"/>
            <div class="my-auto">Back</div>
          </router-link>
          <button class="btn btn-sm" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasAction"
                  aria-controls="staticBackdrop">
            <icon :icon="['fal', 'circle-caret-down']" class="fa-3x"/>
            <div>More actions</div>
          </button>

        </div>

        <div v-if="isMobile()" class="w-100 d-md-none"></div>
        <div class="col d-flex mx-auto">
          <div class="mx-auto">
            <template v-if="filteredPosters">
              <router-link class="btn btn-sm font-weight-bold" v-if="getPosition() > 0"
                           :to="'/viewer/' + filteredPosters[getPosition() - 1].abstract_id">
                <icon :icon="['fal', 'arrow-left']" class="fa-3x"/>
                <div class="my-auto">Last</div>
              </router-link>
              <button class="btn btn-sm border-0 font-weight-bold disabled" v-else>
                <icon :icon="['fal', 'arrow-left']" class="fa-3x"/>
                <div class="my-auto">Last</div>
              </button>
            </template>
            <template v-if="filteredPosters">
              <router-link class="btn btn-sm font-weight-bold"
                           v-if="filteredPosters.length > getPosition() + 1"
                           :to="'/viewer/' + filteredPosters[getPosition() + 1].abstract_id">
                <icon :icon="['fal', 'arrow-right']" class="fa-3x"/>
                <div class="my-auto">Next</div>
              </router-link>
              <button class="btn btn-sm border-0 font-weight-bold disabled" v-else>
                <icon :icon="['fal', 'arrow-right']" class="fa-3x"/>
                <div class="my-auto">Next</div>
              </button>
            </template>
          </div>
        </div>
      </div>
      <div class="row w-100">
        <!--<div class="col-1 col-xl-1"></div>-->
        <div class="col border d-flex w-100" v-if="poster && poster.content">
          <pdf v-if="isIOS === false" :src="pdfdata" :key="page" :id="page" :page="page" :scale.sync="scale"
               :resize="false"
               style="width:100%;" class="mx-auto">
          </pdf>
          <img v-if="isIOS === true" :src="getPDFUrl('thumb')" class="img-fluid mx-auto" alt="eposter"/>
          <!--TODO: Wieder einbauen irgendwie. Hat das Rating behindert-->
          <!--<a class="carousel-control-prev pointer-click" v-on:click="page&#45;&#45;" v-if="page > 1" role="button">-->
          <!--<span class="carousel-control-prev-icon" aria-hidden="true"></span>-->
          <!--<span class="sr-only">Previous</span>-->
          <!--</a>-->
          <!--<a class="carousel-control-next pointer-click" v-on:click="page++" v-if="page < numPages" role="button">-->
          <!--<span class="carousel-control-next-icon" aria-hidden="true"></span>-->
          <!--<span class="sr-only">Next</span>-->
          <!--</a>-->
        </div>
      </div>
    </div>
    <loader v-else></loader>
    <div class="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1"
         id="offcanvasComments" aria-labelledby="offcanvasScrollingLabel">
      <div class="offcanvas-header">
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>

      <div class="offcanvas-body">
        <Comment :poster_id="poster.id" v-if="poster && poster.id"></Comment>
      </div>
    </div>
    <div class="offcanvas offcanvas-start" data-bs-backdrop="static" tabindex="-1" id="offcanvasAction"
         aria-labelledby="staticBackdropLabel">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="staticBackdropLabel">More actions</h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body">
        <div v-if="poster && poster.content">
          <button class="btn btn-outline-primary text-white mt-auto d-flex" data-bs-dismiss="offcanvas">
            <icon :icon="['fal', 'xmark']" class="fa-3x"/>
            <span class="my-auto">&nbsp;Close</span>
          </button>
          <router-link class="btn d-flex" :to="'/viewer/abstract/' + poster.abstract_id"
                       title="Switch to abstract">
            <icon :icon="['fab', 'wpforms']" class="fa-3x"/>
            <span class="my-auto">&nbsp;Abstract</span>
          </router-link>
          <router-link class="btn d-flex mt-3" :to="'/viewer/video/' + poster.abstract_id"
                       v-if="poster.content.video"
                       title="Switch to abstract">
            <icon :icon="['fal', 'film']" class="fa-3x"/>
            <span class="my-auto">&nbsp;Video</span>
          </router-link>
          <a class="btn d-flex mt-3" target="_blank" :href="getPDFUrl('poster')"
             v-if="poster.content.confirm_download && poster.content.confirm_download === true">
            <icon :icon="['fal', 'file-download']" class="fa-3x"/>
            <span class="my-auto">&nbsp;Download</span>
          </a>
          <button class="btn d-flex mt-3"
                  v-on:click="openContact(poster.abstract_id)">
            <icon :icon="['fal', 'message']" class="fa-3x"/>
            <span class="my-auto">&nbsp;Contact</span>
          </button>
          <hr>
          <Comment :poster_id="poster.id" v-if="poster && poster.id"></Comment>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapGetters, mapMutations} from 'vuex'
import Rating from "../components/Rating";
import axios from 'axios'
import Loader from '../components/Loader';
import Comment from "@/views/Comment";
import pdfvuer from 'pdfvuer'
import AudioPlayer from "../components/AudioPlayer";
import {Modal} from "bootstrap";

export default {
  name: "ViewerPDF",
  components: {AudioPlayer, Comment, Rating, Loader, pdf: pdfvuer},
  computed: {
    ...mapState(['fullscreen', 'poster']),
    ...mapGetters([
      'filteredPosters',
    ]),
    isIOS: function () {
      const ua = navigator.userAgent
      if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        return true
      }
      return false
    }
  },
  data() {
    return {
      show: true,
      loadedRatio: 0,
      page: 1,
      numPages: 1,
      rotate: 0,
      scale: 'page-width',
      pdfdata: undefined,
    }
  },
  methods: {
    ...mapActions({
      getPosterById: 'getPosterById',
    }),
    ...mapMutations(['setContactPoster']),
    setScale(newScale) {
      this.scale = newScale;
    },
    getPosition() {
      let index = this.filteredPosters.findIndex(object => {
        return object.abstract_id === parseInt(this.$route.params.id);
      });
      return index;
    },
    getClasses() {
      let code = 'col col-xl-7 offset-xl-2 col-12 border overflow-auto';
      if (this.$store.state.fullscreen === true) {
        code = 'col border overflow-auto';
      }
      return code;
    },
    async getPdf() {
      this.$store.commit('setPoster', {});
      this.getPosterById(this.$route.params.id).then((response) => {
        this.$store.commit('setPoster', response.data);
        let self = this;
        self.pdfdata = pdfvuer.createLoadingTask(this.getPDFUrl(this.$route.name));
        self.pdfdata.then(pdf => {
          self.numPages = pdf.numPages;
        });
      }).catch((error) => {
      })
    },
    getPDFUrl(target) {
      let src = '';
      if (!this.poster || !this.poster.content) {
        return src;
      }
      if (target === 'poster') {
        src = this.poster.content.poster;
      } else if (target === 'additional_paper') {
        src = this.poster.content.additional_paper;
      } else if (target === 'thumb') {
        return 'https://ebmt23poster-188ab.kxcdn.com/' + this.poster.content.poster + '.png';
      }
      return process.env.VUE_APP_PATH_S3URL + src;
    },
    getAudioUrl(src) {
      return process.env.VUE_APP_PATH_S3URL + src;
    },
    getBackUrl() {
      return '/view/' + this.$route.params.id;
    },
    toggleFullscreen() {
      this.$store.state.fullscreen = !this.$store.state.fullscreen;
    },
    showVideo(video) {
      this.$store.state.presentationSite = this.page;
      this.$router.push('/viewer/video/' + video);
    },
    keyPressed: function (event) {
      if ((event.which === 37 || event.which === 33) && this.page > 1) {
        this.page--;
      }
      if ((event.which === 39 || event.which === 34) && this.page < this.numPages) {
        this.page++;
      }
    },
    forceFileDownload(response) {
      this.$store.dispatch('TRACK_ACTION', {
        'value': this.$route.params.id,
        'action': 'download/pdf',
        'source': process.env.VUE_APP_GOOGLE_ANALYTICS_NAME
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', process.env.VUE_APP_PATH_S3URL + this.$store.state.poster.content.poster);
      document.body.appendChild(link);
      link.click();
    },
    downloadWithAxios(src) {
      axios({
        method: 'get',
        url: this.getPDFUrl(src),
        responseType: 'arraybuffer'
      })
          .then(response => {
            this.forceFileDownload(response)
          })
          .catch(() => alert('error occured'))
    },
    error: function (err) {
    },
    openContact(poster_id) {
      this.setContactPoster(this.$route.params.id);
      let modal = new Modal(document.getElementById('modalContact'));
      modal.show();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.page = 1;
    next();
  },
  mounted() {
    this.$store.state.fullscreen = true;
  },
  created() {
    this.$store.dispatch('TRACK_ACTION', {
      'value': this.$route.params.id,
      'action': 'viewer/pdf',
      'source': process.env.VUE_APP_GOOGLE_ANALYTICS_NAME
    });
    window.addEventListener('keyup', this.keyPressed);
    this.getPdf();
    if (this.$store.state.presentationSite > 0) {
      this.page = this.$store.state.presentationSite;
    }
  }
}
</script>
<style src="pdfvuer/dist/pdfvuer.css"></style>
